import { Box } from '@mui/material'
import React from 'react'
import Button from './Button'
import CheckBox from './CheckBox'
import Dialog from './Dialog'
import StripePrefill from './StripePrefill'
import Txt from './Txt'
import getStripeLink from '../mutations/getStripeLink'
import { handleMutationError } from '../utils/errors'
import { Restaurant } from '../utils/restaurant'

const StripeOnboarding = ({ restaurant }: { restaurant?: Restaurant | null }): JSX.Element => {
	const restaurantId = restaurant?.id ?? null
	const company = restaurant?.company ?? null
	const [isTest, setIsTest] = React.useState(false)
	const [loading, setLoading] = React.useState(false)
	const [onboardingUrl, setOnboardingUrl] = React.useState<string | null>(null)

	const handleIsTestChange = React.useCallback((checked: boolean) => {
		setIsTest(checked)
	}, [])

	// Der Link wird vor Ort sofort geöffnet; die Mail an die Firma geht zusätzlich raus.
	const handleStart = React.useCallback(async () => {
		if (!restaurantId) return
		setLoading(true)
		const res = await getStripeLink({ restaurantId, isTest })
		setLoading(false)
		if (!res.success) {
			handleMutationError('getStripeLink', res.errors)
		} else if (res.url) {
			setOnboardingUrl(res.url)
			window.open(res.url, '_blank')
		} else {
			Dialog.render({
				title: 'Kein Onboarding-Link',
				description: 'Stripe hat keinen Link zurückgegeben. Bitte die Logs prüfen.',
			})
		}
	}, [restaurantId, isTest])

	return (
		<Box display="flex" flexDirection="column" alignItems="flex-start" gap="1rem" width="100%">
			<StripePrefill company={company} />
			<Box>
				<CheckBox label="Stripe Sandbox" defaultValue={isTest} onChange={handleIsTestChange} />
				<Txt variant="body2" color="text.secondary" m="0">
					Der Connect-Account entsteht im Testmodus, keine echten Auszahlungen.
				</Txt>
			</Box>
			<Button variant="outlined" onClick={handleStart} loading={loading} disabled={!restaurantId}>
				Starten
			</Button>
			{onboardingUrl ? (
				<Txt
					variant="body2"
					m="0"
					navigateToExternal
					navigateTo={onboardingUrl}
					color="primary.main"
				>
					Onboarding-Link erneut öffnen
				</Txt>
			) : null}
		</Box>
	)
}

export default React.memo(StripeOnboarding)
